exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".CustomerPhone {\n  width: 100%;\n  display: grid;\n  grid-template-columns: minmax(80px, 120px) 1fr;\n  grid-gap: 1rem;\n  gap: 1rem; }\n  .CustomerPhone__country {\n    width: 100% !important; }\n  .CustomerPhone__input--full {\n    width: 100% !important; }\n  .CustomerPhone__input--national {\n    width: 100% !important; }\n", ""]);

